import { useEffect, useState } from "react";
import { usePost } from "./API";
import { toast } from "react-toastify";
import { useLocalizedStrings } from "./Localization";
import { BUTTON_CLASS } from "./Util";
import { ExclamationCircleIcon } from "@heroicons/react/outline";

export function VerificationPage(props: any) {
    const params = new URLSearchParams(window.location.search);
    const challenge = params.get("challenge");

    const verify = usePost('/confirm/check_link');
    const [confirmed, setConfirmed] = useState(false);

    useEffect(() => {
        (async () => {
            if (!challenge) return;
            setConfirmed(await verify({ key: challenge }));
        })()
    }, [challenge]);

    return confirmed ? <div>Verified! Thank you.</div> : <div>Verifying...</div>;
}

export function ConfirmationStep(props: { 
    supportCaseId?: string, 
    // If the user needs to click a button to start the verification process
    needReady?: boolean, 
    // For holding the state if the user switches tabs
    sent?: string, 
    setSent: (email: string) => void,
    // A list of emails which have been verified
    verified?: string[]
}) {

    const L = useLocalizedStrings();
    const [ready, setReady] = useState(!props.needReady);
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(props.sent || '');
    const sendLinkVerification = usePost('/confirm/send_link');

    // if state is updated outside this component we need to update here too
    useEffect(() => {
        setSent(props.sent || '');
    }, [props.sent]);

    if (sent) return <div>
        <p>We sent an email with a link to {sent}</p>
        <p>Please have the person you are helping check their email inbox and spam folders for the email with the link.
        After they have clicked the link, you will see the email under "Verified Contacts".</p>
    </div>

    return <div>
        {props.verified ? <div><h2>Verified Contacts</h2><ul>
            {props.verified.map(v => <li key={v} style={{listStyle: "none"}}>✅ {v}</li>)}
        </ul></div> : null}
        {ready ? <form className="mt-3 p-0" onSubmit={async (e) => {
        if (e.currentTarget.checkValidity()) {
            e.preventDefault();
        }
        const response = await sendLinkVerification({ ...props, kind: "email", email })
        if (response?.status) {
            toast.success(L.applicant.comms.sent);
        }
        setSent(email);
        props.setSent(email);
        // Clear email
        setEmail('');
    }}>
        <div>
            {props.needReady && <div className="float-right top-0 -mt-4 right-2">
                <button className="" onClick={() => setReady(false)}>X</button>
            </div>}
            <label htmlFor="email" className="block text-lg font-medium leading-6 text-gray-900">
                Enter an Email to Verify
            </label>
            <div className="mt-2">
                <input type="email" name="email_to_verify" id="email"
                    pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    autoComplete="off" value={email}
                    onChange={(e) => { 
                        const value = e.target.value;
                        setEmail(value)
                    }}
                    aria-describedby="email-desription" required
                    className="block w-3/4 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="" />
            </div>
            <p className="mt-2 text-sm text-gray-500" id="email-description">
                We'll send a verification link to their email.
            </p>
        </div>
        <button className={BUTTON_CLASS} type="submit">Send Verification Link</button>
    </form> : <div>
        <button onClick={() => setReady(true)} className={BUTTON_CLASS}>
            Verify an Email
        </button>
    </div>}
    </div>
}